import React from 'react';
import { Link } from 'react-router-dom';
import GridProperty from '../../../components/grid-property';

interface MorePropertiesSectionProps {
    project: any;
    devProperties: any[];
}

const MorePropertiesSection: React.FC<MorePropertiesSectionProps> = ({ project, devProperties }) => {
    if (devProperties.length === 0) return null;

    return (
        <div className="flex flex-wrap -mx-3 mt-8 pt-6 border-t border-gray-200">
            <div className="w-full px-6 mb-6">
                <div className="flex items-center justify-between flex-wrap gap-2">
                    <h4 className="font-bold mb-0 text-gray-900">
                        More Properties by {project.developer?.name || (project.developer?.role === 'owner' ? 'this Owner' : project.developer?.role === 'broker' ? 'this Broker' : 'this Developer')}
                    </h4>
                    <Link 
                        to={project.developer?.role === 'owner' ? `/owner-profile/${project.developer?._id}` : project.developer?.role === 'broker' ? `/agent-page/${project.developer?._id}` : `/developer-page/${project.developer?._id}`} 
                        className="inline-block text-center cursor-pointer transition-all btn-link text-primary text-decoration-none font-bold p-0"
                    >
                        View All Properties <i className="fa-solid fa-arrow-right ml-1"></i>
                    </Link>
                </div>
            </div>
            <div className="flex flex-wrap -mx-3">
                {devProperties.slice(0, 3).map((prop) => (
                    <div className="w-full lg:w-1/3 px-6 md:w-1/2" key={prop._id}>
                        <GridProperty item={prop} border={true} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MorePropertiesSection;
